import { defineComponent as _defineComponent } from 'vue'

  const __default__ = {
    name: 'NestedDraggable',
  }

import { ref } from "vue";
import draggable, { MoveEvent } from "vuedraggable";
import { TableItem } from './types';
import CheckBox from '../../components/selection-controls/CheckBox.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    items: null,
    onChange: null,
    onMove: null,
    onStart: null,
    headersLength: null,
    isDragAreaExpanded: { type: Boolean },
    containsActions: { type: Boolean },
    dropzoneItem: null,
    disableDrag: { type: Boolean, default: false },
    selectedRows: { default: () => [] },
    selectable: { type: Boolean, default: false }
  },
  emits: ["input", "row-select"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value: TableItem[]): void;
  (e: 'row-select', item: number | (string | number)[] | string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { items: TableItem[], onChange: () => void, onMove: (event: MoveEvent<TableItem>) => void, onStart: () => void, headersLength: number, isDragAreaExpanded: boolean, containsActions: boolean, dropzoneItem: string, disableDrag: boolean, selectedRows: (string| number)[], selectable: boolean };




const expanded = ref<(number | string)[]>([]);

function expandRows(rowId: number | string) {
  if(props.items.find(item => item.id === rowId)?.children.length){
    expanded.value = expanded.value.includes(rowId) ? expanded.value.filter(id => id !== rowId) : expanded.value.concat(rowId);
  }
}

function selectRowItem(item: number | string) {
  emit('row-select', item);
}


return { __sfc: true,props, emit, expanded, expandRows, selectRowItem, draggable, CheckBox }
}

})